import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
}
export function CountdownTimer({
  initialHours = 2,
  initialMinutes = 14,
  initialSeconds = 10,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialHours * 3600 + initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatDigit = (digit: number) => digit.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center mx-1 sm:mx-2" data-id="element-182">
      <div className="bg-zinc-900 border border-zinc-800 text-white font-bold text-2xl sm:text-4xl rounded-lg w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center shadow-inner shadow-black/50" data-id="element-183">
        {value}
      </div>
      <span className="text-[10px] sm:text-xs text-zinc-500 mt-1 uppercase tracking-wider font-semibold" data-id="element-184">
        {label}
      </span>
    </div>;
  return <div className={`flex items-center justify-center ${className}`} data-id="element-185">
      <TimeBox value={formatDigit(hours)} label="Horas" data-id="element-186" />
      <span className="text-2xl sm:text-4xl font-bold text-zinc-600 -mt-5 animate-pulse" data-id="element-187">
        :
      </span>
      <TimeBox value={formatDigit(minutes)} label="Minutos" data-id="element-188" />
      <span className="text-2xl sm:text-4xl font-bold text-zinc-600 -mt-5 animate-pulse" data-id="element-189">
        :
      </span>
      <TimeBox value={formatDigit(seconds)} label="Segundos" data-id="element-190" />
    </div>;
}